import { Card, Result, message } from "antd";
import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { tokenLoginAction } from "../store/action/shared/authAction";
import CustomLoaderIcon from "../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";

function POCLogin() {
  const location = useLocation();
  const router = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const paramValue = searchParams.get("token");
  const dispatch = useDispatch();
  const loginWithToken = async () => {
    try {
      await dispatch(tokenLoginAction(paramValue));
      router("/manager/job-posts");
    } catch (err) {
      message.error(err);
      router("/login");
    }
  };
  useEffect(() => {
    loginWithToken();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <Card style={{ maxWidth: "400px" }}>
        <Result
          status="success"
          title="Success!"
          subTitle={
            <>
              <span>Redirecting to dashboard, please wait.</span>
              <CustomLoaderIcon />
            </>
          }
        />
      </Card>
    </div>
  );
}

export default POCLogin;
